import {KeyValue} from "../keyValue";
import {LayoutOrientation} from "../../../shared/enums/layoutOrientation";

// Abstract class which defines a pattern for the items we render in a radio group
export abstract class RadioGroupKeyValue extends KeyValue {
  // support for tooltip on all radio group items
  tooltip?: string;
  isDisabled?: boolean;
  helpText?: string;
  // How the item and it's custom input should be layout
  orientation?: LayoutOrientation;

  constructor(
    value: string,
    label: string,
    tooltip?: string,
    isDisabled?: boolean,
    helpText?: string,
    orientation = LayoutOrientation.Grid
  ) {
    super(value, label);
    this.tooltip = tooltip;
    this.isDisabled = isDisabled;
    this.helpText = helpText;
    this.orientation = orientation;
  }

  // Abstract methods allowing for custom input
  abstract get hasCustomInput(): boolean;
  abstract renderCustomInput(isDisabled: boolean): JSX.Element | null;
  abstract get enteredValue(): string;

  get hasTooltip(): boolean {
    return !!this.tooltip;
  }
}
